module.exports = __webpack_public_path__ + "static/img/b5.2592cda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b5.jpg
// module id = Y8vB
// module chunks = 1